module.exports = __webpack_public_path__ + "static/img/tgqqg-01.fdf8093.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tgqqg-01.svg
// module id = 8EA+
// module chunks = 1